(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-add-to-cart-button"] && !Shopify.designMode) return;
  try {
    /* 09/10/2026 — Le thème ne rafraîchit que le bouton au changement de finition : on remplace aussi
     l'état du stock de la barre collante, depuis le HTML que la sélection de variante vient de charger. */
  /* 16/10/2026 — on remplace tout le bloc produit (vignette de la finition comprise), puis on recopie la date
     de livraison du bloc `mf-livraison` de la fiche (la dernière date affichée = la date estimée). */
  const mfRemplirLivraison = () => {
    const cible = document.querySelector('[data-ref="sticky-livraison"]');
    const dates = document.querySelectorAll('.mf-livraison__date');
    const date = dates.length ? dates[dates.length - 1].textContent.trim() : '';
    if (!cible || !date) return;
    /* 19/10/2026 — préfixe (« le » / « on ») lu dans la traduction, pour la version anglaise. */
    const le = cible.dataset.le || 'le';
    cible.querySelector('strong').textContent = date.toLowerCase().startsWith(`${le.toLowerCase()} `) ? date : `${le} ${date}`;
    cible.hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mfRemplirLivraison);
  else mfRemplirLivraison();

  document.addEventListener('variant:updated', (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;
    const nouveau = html.querySelector('[data-ref="sticky-produit"]');
    const actuel = document.querySelector('[data-ref="sticky-produit"]');
    if (nouveau && actuel) actuel.replaceWith(nouveau);
    mfRemplirLivraison();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mf-livraison"] && !Shopify.designMode) return;
  try {
    /* 16/10/2026 — Le thème ne rafraîchit pas ce bloc au changement de finition : on remplace la ligne
     « En stock, livré chez vous… » depuis le HTML que la sélection de variante vient de charger. */
  document.addEventListener('variant:updated', (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;
    const nouveau = html.querySelector('[data-ref="mf-livraison-stock"]');
    const actuel = document.querySelector('[data-ref="mf-livraison-stock"]');
    if (nouveau && actuel) actuel.replaceWith(nouveau);
  });
  } catch(e) { console.error(e); }
})();

})();
